export const TRANS = {
  show: { en: 'Show', fi: 'Näytä' },
  hide: { en: 'Hide', fi: 'Piilota' },
};
